export default __webpack_public_path__ + "static/media/0_3_BEXEN_Cardio_Horiz.aff45142.png";